

export function addToWishlist(product, wishlist) {
  return wishlist.find(w=> w.id === product.id && w.format === product.format) ? wishlist : wishlist.concat(product);
}

export function addToWishlistO(product, wishlist) {
  return wishlist.find(w=> w.id == product.id && (( w.format === product.format ) || ( !w.format && !product.format))) ? wishlist : wishlist.concat(product);
}

export function removeFromWishlist(product, wishlist) {
  return wishlist.filter(w=> !(w.id == product.id && w.format === product.format));
}

/*
 function test() {
 console.log('[3]', removeFromWishlist(2,[2,3]));
 console.log('[3,4]', addToWishlist(4,[3]));
 console.log('[3,4,5,6]', addToWishlist(6,[3,4,5]));
 console.log('[3,5,6]', removeFromWishlist(4,[3,4,5,6]));
 }
 */



// WEBPACK FOOTER //
// ./src/shared/wishlist.js